import React from "react";
import { useNavigate } from "react-router-dom";
import useLogOut from "../services/customHook/UseLogout";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';

export default function LogoutRedirection() {

  const navigate = useNavigate();
  const logOut = useLogOut();
  const dispatch = useDispatch();

  useEffect( ()=>{
        logOut();
        navigate("/");
  },[])

  return (
    <div>
        <div>Logging Out ..</div>
    </div>
  );
}
